<div class="">
  <app-login-form (close$)="modal.close()"></app-login-form>
</div>
